export const EULA_DATA = {
  lastUpdated: "September 30, 2025",
  appName: "Exoneree LifeLine",
  contactEmail: "support@example.com",
  sections: [
    {
      title: "Use of Services",
      blocks: [
        {
          type: "p",
          text:
            "You must be at least 18 years old (or the legal age in your jurisdiction) to use the Services.",
        },
        {
          type: "p",
          text:
            "You agree to use the Services only for lawful purposes and in compliance with all applicable laws.",
        },
        {
          type: "p",
          text:
            "You are responsible for maintaining the confidentiality of your account information.",
        },
      ],
    },
    {
      title: "Requests and Transactions",
      blocks: [
        {
          type: "p",
          text:
            "The Services allow you to submit, receive, and manage requests (“Requests”).",
        },
        {
          type: "p",
          text:
            "We do not guarantee the availability, accuracy, or outcome of any Request.",
        },
        {
          type: "p",
          text:
            "You are solely responsible for any content or information you provide through a Request.",
        },
      ],
    }
    //..etc etc
  ],
};